import React, { useState, useEffect, useRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import axios from 'axios';
import Swal from 'sweetalert2';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import {baseUrl, userLocation, ipAddress, userName} from '../Univ.js'

const FullPageCalendar = () => {
  const [date, setDate] = useState(new Date());
  const [timeSlots, setTimeSlots] = useState([]);
    const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const calendarRef = useRef();

  useEffect(() => {
    fetchEventsData();
  }, []);

const fetchEventsData = async () => {
  try {
    setIsLoading(true);
    const response = await axios.get(`${baseUrl}get-events/`);
    const eventsData = response.data;
    const formattedEvents = eventsData.map((event) => ({
      id: event.id,
      title: event.title,
      start: utcToZonedTime(new Date(event.start_date), 'Asia/Kolkata'),
      end: utcToZonedTime(new Date(event.end_date), 'Asia/Kolkata'),
    }));
    setTimeSlots(formattedEvents);
    setEvents(formattedEvents);
  } catch (error) {
    console.error('Error fetching events data:', error);
    alert('Failed to fetch events. Please try again.');
  } finally {
    setIsLoading(false);
  }
};

const handleSelectSlot = (info) => {
  const startDateTime = info.start;
  const endDateTime = info.end;

  // Function to combine date and time into a single DateTime object
  const combineDateAndTime = (date, time) => {
    const timeString = time.toISOString().split('T')[1];
    const combinedDateTimeString = `${date.toISOString().split('T')[0]}T${timeString}`;
    return new Date(combinedDateTimeString);
  };

  const startDate = new Date(startDateTime);
  const startTime = new Date(startDateTime);

  const endDate = new Date(endDateTime);
  const endTime = new Date(endDateTime);

  handleAppointmentBooking(combineDateAndTime(startDate, startTime), combineDateAndTime(endDate, endTime));
};


  const handleDateClick = (info) => {
    console.log('handleDateClick triggered');
    setDate(info.date);
  };

  const handleEventClick = (info) => {

    if (window.confirm('Are you sure you want to remove it?')) {
      const eventId = info.event.id;
      handleAppointmentDeletion(eventId);
    }
  };

  const handleAppointmentBooking = async (startDateTime, endDateTime) => {
  const title = document.getElementById("title").value;
  const remarks = document.getElementById("remarks").value;
  if (!title) {
    Swal.fire('Error', 'Please Enter the Title of the Event.', 'error');
    return;
  }

  const formattedStartDate = format(startDateTime, 'yyyy-MM-dd HH:mm:ss');
  const formattedEndDate = format(endDateTime, 'yyyy-MM-dd HH:mm:ss');

  try {
    calendarRef.current.getApi().setOption('selectable', false);
    setIsLoading(true);

    await axios.post(`${baseUrl}add-event/`, {
      title: title,
      remarks: remarks,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      addedby: userName,
      ip_add: ipAddress,
    });

    Swal.fire({
      title: 'Event has been added.',
      icon: 'success',
      timer: 5000,
      showConfirmButton: false
    });
    setTimeout(() => {
      window.location.href = '/events';
    }, 3000);
  } catch (error) {
    console.error('Error booking appointment:', error);
    alert('Failed to book appointment. Please try again.');
  } finally {
    setIsLoading(false);
    calendarRef.current.getApi().setOption('selectable', true);
  }
};

  const handleAppointmentDeletion = async (eventId) => {
    try {
    await axios.delete(`${baseUrl}delete-event/${eventId}/`);
    Swal.fire('success', 'Data has been Deleted');
    window.location.reload();
    } catch (error) {
      console.error('Error deleting Event:', error);
    }
  };



  return (
    <section className="container mt-4">
        <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <i className="fa fa-calendar" aria-hidden="true" style={{ color: 'red' }}></i>
           Event Calendar
        </h3>
      <div className="row table-responsive">
      <div className="col-md-6 mt-3">
        <label htmlFor="title" className="form-label">Title:</label>
        <input type="text" id="title" className="form-control" placeholder="Title" required />
      </div>
      <div className="col-md-6 mt-3">
        <label htmlFor="remarks" className="form-label">Remarks:</label>
        <textarea id="remarks" className="form-control" rows="5" placeholder="Remarks"></textarea>
      </div>
    </div>

        <div className="row table-responsive">
        <div className="col-md-12 mt-4">
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          headerToolbar={{
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay',
          }}
          initialView="dayGridMonth"
          timeZone="Asia/Kolkata"
          events={events}
          dateClick={handleDateClick}
          eventClick={handleEventClick}
          select={handleSelectSlot}
          selectable={true}
          ref={calendarRef}
        />
      </div>
    </div>
    </section>
  );
};

export default FullPageCalendar;
